import {getTimezones} from '../../services/TimezoneService';

export default {
  namespaced: true,
  state: {
    timezones: []
  },
  getters: {
    getTimezones: (state) => {
      return state.timezones;
    }
  },
  mutations: {
    setTimezones (state, timezones) {
      state.timezones = timezones;
    }
  },
  actions: {
    async loadTimezones ({commit}) {
      const resposne = await getTimezones();
      commit('setTimezones', resposne.data);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/timezoneModule.js